import { TActivityKind } from '@forwardflow/features/campaign-flow/interfaces/campaign-flow.types'

/** The Conversations screen's own filters for each kind of activity (pages/Conversations). */
const FILTER_OF: Record<TActivityKind, Record<string, string>> = {
   appointment: { stages: 'apt-set' },
   transfer: { leadFilter: 'liveTransfer' },
   reply: { leadFilter: 'textConversations' },
}

/**
 * A link into Conversations with this campaign selected (`campaignId` +
 * `filter` = its name), optionally on one lead and one kind of activity.
 */
export const conversationsLink = (o: {
   campaignId?: string
   campaignName?: string
   leadId?: string
   kind?: TActivityKind | null
}) => {
   const q = new URLSearchParams()
   if (o.campaignId) q.set('campaignId', o.campaignId)
   if (o.campaignName) q.set('filter', o.campaignName)
   if (o.kind)
      Object.entries(FILTER_OF[o.kind]).forEach(([k, v]) => q.set(k, v))
   return `/conversations${o.leadId ? `/${encodeURIComponent(o.leadId)}` : ''}?${q.toString()}`
}

/** "just now", "12 min ago", "3 h ago", "2 days ago". */
/** The backend writes "2026-10-20 23:55:22.088+00"; browsers parse ISO only. */
export const parseDate = (value: string) => {
   const direct = Date.parse(value)
   if (Number.isFinite(direct)) return direct
   return Date.parse(
      value
         .trim()
         .replace(' ', 'T')
         .replace(/([+-]\d{2})$/, '$1:00')
         .replace(/(\.\d{3})\d+/, '$1')
   )
}

export const timeAgo = (iso: string, now = Date.now()) => {
   const t = parseDate(iso)
   if (!Number.isFinite(t)) return ''
   const min = Math.max(0, Math.round((now - t) / 60000))
   if (min < 1) return 'just now'
   if (min < 60) return `${min} min ago`
   const h = Math.round(min / 60)
   if (h < 24) return `${h} h ago`
   const d = Math.round(h / 24)
   return d === 1 ? 'yesterday' : `${d} days ago`
}
